// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__OY4m6","savePackageButton":"ClientWallet_savePackageButton__1fSyW"};